import { template as template_d696e65b04274d3788729f35ae8fe7f8 } from "@ember/template-compiler";
import { eq } from 'ember-truth-helpers';
import Component from '@glimmer/component';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
export default class SiteBillingChannelCoverageInfo extends Component {
    get remainingSessionsCount() {
        return this.args.channelClientInfo?.remainingSessionsCount;
    }
    get channelName() {
        return this.args.channelClientInfo?.globalMonarchChannel?.displayName;
    }
    static{
        template_d696e65b04274d3788729f35ae8fe7f8(`
    <span class="channel-covered">
      {{svgJar "warning-outline" class="icon-warning" aria-hidden="true"}}
      <div class="text">
        {{t
          "billing.coverage.willCover"
          channelName=this.channelName
          count=this.remainingSessionsCount
          appointments=(if
            (eq this.remainingSessionsCount 1)
            (t "billing.coverage.appointment")
            (t "billing.coverage.appointments")
          )
        }}
      </div>
    </span>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
